<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="a__Hlk132640019"><span>Acknowledgments</span></h1>
<p class="P_Normal__And__Left_Indent"><span style=" font-size: 0.93em; text-transform: none;">OH, TO</span> the Five… always. And to Bru, who jumped in on this ride. As well as to Elizabeth, Liz, Naomi, Gin, and everyone else at DSP for letting us go crazy with this.</p>
<p class="P_Normal__And__Left_Indent"> </p>
<p class="P_Normal__And__Left_Indent"> </p>
<p class="P_Normal__And__Left_Indent"> </p>
<p class="P_Normal__And__Left_Indent">.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?2035b136